import { ValidatorFn } from '@angular/forms';
import { Question } from '../../../../classes';

export function questionTitleRequiredValidator (question:Question):ValidatorFn {
    return (): { [key: string]: boolean } => {
        if (!question.text) {
            return {
                question_text_required:true,
            }
        }
        return null;
    }    
}
